module.exports = __webpack_public_path__ + "static/media/close.45ec8f96.svg";